function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".JigSawImage-1{fill:#e5e6eb;}.JigSawImage-2{fill:#d9dae2;}.JigSawImage-3{fill:#cfcfd9;}.JigSawImage-4{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "JigSawImage-1",
  points: "32.35 1 32.35 25 33.35 25 33.35 26 57.35 26 57.35 1 32.35 1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "JigSawImage-2",
  d: "M37,3v9.38A4,4,0,1,1,37.4,18a3.78,3.78,0,0,1-.4-.4V27H27.62A4,4,0,1,0,22,26.6a3.78,3.78,0,0,0,.4.4H13V3Z",
  transform: "translate(-3.65 -2)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "JigSawImage-2",
  d: "M51.62,27A4,4,0,1,0,46,26.6a3.78,3.78,0,0,0,.4.4H37V37.38A4,4,0,1,1,37.4,43a3.78,3.78,0,0,1-.4-.4V51H61V27Z",
  transform: "translate(-3.65 -2)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "JigSawImage-3",
  d: "M37,51H61V27A24,24,0,0,1,37,51Z",
  transform: "translate(-3.65 -2)"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "JigSawImage-4",
  points: "11.35 9 11.35 3 17.35 3 11.35 9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M61,2H13a1,1,0,0,0-1,1V27a1,1,0,0,0,1,1h9.38a1,1,0,0,0,1-1,1,1,0,0,0-.34-.75A3,3,0,0,1,22,24a3,3,0,0,1,6,0,3,3,0,0,1-1,2.25,1,1,0,0,0-.09,1.41,1,1,0,0,0,.75.34H36v9.38a1,1,0,0,0,1,1,1,1,0,0,0,.75-.34A3,3,0,0,1,40,37a3,3,0,0,1,0,6,3,3,0,0,1-2.25-1,1,1,0,0,0-1.41-.09,1,1,0,0,0-.34.75V51a1,1,0,0,0,1,1H61a1,1,0,0,0,1-1V3A1,1,0,0,0,61,2ZM60,26H53.57A4.93,4.93,0,0,0,54,24a5,5,0,0,0-10,0,4.93,4.93,0,0,0,.43,2H38V19.57A4.93,4.93,0,0,0,40,20a5,5,0,0,0,0-10,4.93,4.93,0,0,0-2,.43V4H60ZM25,19a5,5,0,0,0-5,5,4.93,4.93,0,0,0,.43,2H14V4H36v8.38a1,1,0,0,0,1,1,1,1,0,0,0,.75-.34A3,3,0,0,1,40,12a3,3,0,0,1,0,6,3,3,0,0,1-2.25-1,1,1,0,0,0-1.41-.09,1,1,0,0,0-.34.75V26H29.57A4.93,4.93,0,0,0,30,24,5,5,0,0,0,25,19ZM60,50H38V44.57A4.93,4.93,0,0,0,40,45a5,5,0,0,0,0-10,4.93,4.93,0,0,0-2,.43V28h8.38a1,1,0,0,0,1-1,1,1,0,0,0-.34-.75A3,3,0,0,1,46,24a3,3,0,0,1,6,0,3,3,0,0,1-1,2.25,1,1,0,0,0-.09,1.41,1,1,0,0,0,.75.34H60Z",
  transform: "translate(-3.65 -2)"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Image"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.65,56.48h-22a1,1,0,0,1-1-1v-24a1,1,0,0,1,1-1h22a1,1,0,0,1,1,1v24A1,1,0,0,1,26.65,56.48Zm-21-2h20v-22h-20Z",
  transform: "translate(-3.65 -2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.65,60.48h-22a1,1,0,1,1,0-2h21v-22h-1a1,1,0,0,1,0-2h2a1,1,0,0,1,1,1v24A1,1,0,0,1,32.65,60.48Z",
  transform: "translate(-3.65 -2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.65,51.34a1,1,0,0,1-.7-.29,1,1,0,0,1,0-1.41L8,45.48a2.68,2.68,0,0,1,3.48-.29l3.59,2.6a.67.67,0,0,0,.88-.08L19.65,44a2.75,2.75,0,0,1,3.82,0l3.88,3.93a1,1,0,0,1-1.42,1.4l-3.88-3.93a.69.69,0,0,0-1,0l0,0-3.71,3.75a2.67,2.67,0,0,1-3.48.3l-3.59-2.6a.67.67,0,0,0-.88.07L5.36,51A1,1,0,0,1,4.65,51.34Z",
  transform: "translate(-3.65 -2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5,42.34a4,4,0,1,1,4-4A4,4,0,0,1,16.5,42.34Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,16.5,36.34Z",
  transform: "translate(-3.65 -2)"
}));

var SvgJigSawImage = function SvgJigSawImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JigSawImage",
    viewBox: "0 0 58.35 58.48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJigSawImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/JigSawImage.6a047f79.svg";
export { ForwardRef as ReactComponent };